import { useEffect } from "react"
import { useRouterState } from "@tanstack/react-router"
import { usesAppChrome, usesInkDeskChrome } from "@/lib/marketing-chrome"

const APP_SHELL_FONTS_ID = "hsrfc-app-shell-fonts"
const APP_SHELL_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&family=Fraunces:opsz,wght@9..144,500;9..144,600&display=swap"

/** Loads Fraunces + DM Sans only on forest SiteHeader desks (admin / legacy). */
export function AppShellFonts({
  role,
}: {
  role?: "employer" | "seeker" | null
}) {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const opts = { role: role ?? null }
  const needsAppFonts =
    usesAppChrome(pathname, opts) && !usesInkDeskChrome(pathname, opts)

  useEffect(() => {
    const existing = document.getElementById(APP_SHELL_FONTS_ID)
    if (!needsAppFonts) {
      existing?.remove()
      return
    }
    if (existing) return
    const link = document.createElement("link")
    link.id = APP_SHELL_FONTS_ID
    link.rel = "stylesheet"
    link.href = APP_SHELL_FONTS_HREF
    document.head.appendChild(link)
  }, [needsAppFonts])

  return null
}
